<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 20px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="主阀门">
                <a-input v-model="query.mainValveClassNos" placeholder="请输主阀门！" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="互通阀门">
                <a-input v-model="query.interworkingValveClassNos" placeholder="请输入互通阀门！" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="方案名称">
                <a-input v-model="query.planName" placeholder="请输入方案名称！" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="状态">
                <a-select placeholder="请选择状态" v-model="query.isEnable" allow-clear>
                  <a-select-option value="0"> 启用 </a-select-option>
                  <a-select-option value="1"> 不启用 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        rowKey="id"
        :scroll="{ x: 1800 }"
        :columns="columns"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :pagination="pagination"
        @change="pageChange"
        bordered
      >
        <span slot="isEnable" slot-scope="text">
          <span v-if="text == 0"> 启用 </span>
          <span v-else> 不启用 </span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record.id)" v-action:edit>编辑</a>
        </span>
      </a-table>
      <a-modal :title="this.title" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form-model
          class="log-form"
          :model="addOrUpdateForm"
          ref="addOrUpdateForm"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-row class="form-row" type="flex" justify="center" :gutter="4">
            <a-col :md="24" :sm="24">
              <a-form-model-item label="状态" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }" prop="isEnable">
                <a-radio-group v-model="addOrUpdateForm.isEnable" style="width: 80%">
                  <a-radio :value="0">开启</a-radio>
                  <a-radio :value="1">不开启</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-model-item label="方案名称" prop="planName">
                <a-input style="width: 95%" v-model="addOrUpdateForm.planName" placeholder="请输入方案名称" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <div v-for="(item, index) in this.addOrUpdateForm.valueDTOList" :key="index">
            <a-row>
              <a-col :span="23">
                <a-form-model-item label="主阀门" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" prop="">
                  <a-select
                    mode="multiple"
                    style="width: 95%"
                    placeholder="请输入八位数关键字"
                    @search="Interconnection"
                    :filter-option="false"
                    :not-found-content="fetchingk ? undefined : null"
                    v-model="addOrUpdateForm.valueDTOList[index].mainValveIds"
                  >
                    <a-select-option v-for="item in gisMainValveIds" :key="item.id" :value="item.id">{{
                      item.class_no
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="1">
                <a-button
                  v-if="item.flag"
                  size="small"
                  type="primary"
                  style="font-size: 12px; margin-left: -129px; height: 30px; font-size: 12px; margin-top: 4px"
                  @click="natureclick(naturclicks)"
                >
                  添加
                </a-button>
                <a-button
                  v-if="!item.flag"
                  size="small"
                  type="danger"
                  style="font-size: 12px; margin-left: -129px; height: 30px; font-size: 12px; margin-top: 4px"
                  @click="deleteArr(index)"
                >
                  删除
                </a-button>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="23">
                <a-form-model-item label="互通阀门" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" prop="">
                  <a-select
                    mode="multiple"
                    style="width: 100%"
                    placeholder="请输入八位数关键字"
                    @search="filterOption"
                    :filter-option="false"
                    :not-found-content="fetching ? undefined : null"
                    v-model="addOrUpdateForm.valueDTOList[index].interworkingValveIds"
                  >
                    <a-select-option v-for="item in gisInterworkingValveIds" :key="item.id" :value="item.id">{{
                      item.class_no
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="1"> </a-col>
            </a-row>
          </div>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>
<script>
import mixinViewModule from '@/mixin/common'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      title: '新增',
      isUpdate: false,
      disabled: false,
      visibles: false,
      equipmentList: [],
      parameterList: [],
      queryUrl: '/pipe-network/gis_interworking_valves/page',
      addOrUpdateUrl: '/pipe-network/gis_interworking_valves',
      deleteUrl: '/pipe-network/gis_interworking_valves', // 删除数据url
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryOneUrl: '/pipe-network/gis_interworking_valves/',
      visible: false,
      confirmLoading: false,
      fetching: false,
      fetchingk: false,
      list: [],
      zoneTreeData: [], // 分区数据选项
      typelist: [],
      typelists: [],
      gisMainValveIds: [],
      gisInterworkingValveIds: [],
      query: {
        interworkingValveClassNos: '',
        mainValveClassNos: '',
        planName: '',
        interworkingValve: '',
        isEnable: '',
      },
      addOrUpdateForm: {
        isEnable: 0,
        planName: '',
        valueDTOList: [
          {
            interworkingValveIds: [],
            mainValveIds: [],
            flag: true,
          },
        ],
      },
      naturclicks: 1,
      columns: [
        {
          title: '方案名称',
          dataIndex: 'planName',
        },
        {
          title: '主阀门',
          dataIndex: 'mainValveClassNos',
          ellipsis: true,
        },
        {
          title: '互通阀门',
          dataIndex: 'interworkingValveClassNos',
          scopedSlots: { customRender: '' },
          ellipsis: true,
        },
        {
          title: '启用状态',
          dataIndex: 'isEnable',
          scopedSlots: { customRender: 'isEnable' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
      // addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },
  computed: {
    rules() {
      return {
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
        planName: [{ required: true, message: '请输入方案名称', trigger: 'change' }],
        mainValveIds: [{ required: true, message: '请输入主阀门', trigger: 'change' }],
        interworkingValveIds: [{ required: true, message: '请输入互通阀门', trigger: 'change' }],
      }
    },
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.resetList()
    this.queryList()
  },
  methods: {
    filterOption(input, option) {
      if (input.length > 8) {
        this.fetching = true
        const params = {
          classNo: input,
        }
        this.$http.get('/pipe-network/gis/pipe-networks/list/valve', { params }).then((res) => {
          this.gisInterworkingValveIds = res.data
        })
      } else {
        return (this.gisInterworkingValveIds = [])
      }
    },
    Interconnection(input, option) {
      if (input.length > 8) {
        this.fetchingk = true
        this.$http
          .get('/pipe-network/gis/pipe-networks/list/valve', {
            params: {
              classNo: input,
            },
          })
          .then((res) => {
            this.gisMainValveIds = res.data
          })
      } else {
        return (this.gisMainValveIds = [])
      }
    },
    deleteArr(index) {
      this.addOrUpdateForm.valueDTOList.splice(index, 1)
    },
    natureclick(i) {
      let obj = {
        interworkingValveIds: [],
        mainValveIds: [],
        flag: false,
      }
      if (this.addOrUpdateForm.valueDTOList.length <= 4) {
        this.addOrUpdateForm.valueDTOList.push(obj)
      }
    },
    handleChange(e) {},
    Handle(e) {
      this.disabled = true
      this.addOrUpdateHandle(e)
      this.showModal()
      this.resetList()
    },
    showModal() {
      this.visible = true
    },
    addOrUpdateHandle(id) {
      if (id == undefined) {
        this.title = '新增'
      } else {
        this.title = '编辑'
      }
      this.isUpdate = false
      this.currentId = id
      // this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            ;(this.addOrUpdateForm = {
              isEnable: data.isEnable,
              planName: data.planName,
              valueDTOList: [],
            }),
              (this.gisMainValveIds = data.gisMainS)
            this.gisInterworkingValveIds = data.gisInterworkingS
            data.valueDTOList.map((item) => {
              this.addOrUpdateForm.valueDTOList.push({
                interworkingValveIds: item.interworkingValveIds,
                mainValveIds: item.mainValveIds,
                flag: false,
              })
            })
            this.addOrUpdateForm.valueDTOList[0].flag = true
            this.addOrUpdateForm.setFieldsValue(data)
            this.gisMainValveIds = []
            this.gisInterworkingValveIds = []
          })
          .catch(() => {})
      }
    },
    handleOk() {
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](
            this.addOrUpdateUrl,
            this.query.sysType
              ? { id: this.currentId, sysType: this.query.sysType, ...this.addOrUpdateForm }
              : { id: this.currentId, ...this.addOrUpdateForm }
          )
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                ;(this.addOrUpdateForm.valueDTOList = [
                  {
                    interworkingValveIds: [],
                    mainValveIds: [],
                    flag: true,
                  },
                ]),
                  (this.addOrUpdateForm.planName = '')
                this.$refs.addOrUpdateForm.resetFields()
                this.queryList()
                this.gisMainValveIds = []
                this.gisInterworkingValveIds = []
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    //取消
    handleCancel(e) {
      this.$refs.addOrUpdateForm.resetFields()
      ;(this.addOrUpdateForm.valueDTOList = [
        {
          interworkingValveIds: [],
          mainValveIds: [],
          flag: true,
        },
      ]),
        (this.addOrUpdateForm.planName = ''((this.visible = false)))
      this.gisMainValveIds = []
      this.gisInterworkingValveIds = []
      this.disabled = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/ .ant-table-thead > tr > th > {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}
</style>